require('./eventModals.scss')

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ModalCustom } = require('commonsComponents/modalCustom');
const { OKButton } = require('commonsComponents/OKButton');

// @helpers
const { formatText } = require('core/i18n').i18n;

class EventModals extends React.Component {
    constructor(props) {
        super(props);
        this.handleSaveClick = this.handleSaveClick.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleSaveClick() {
        //API call
        this.props.actionsObject.rightButtonAction();
    }

    handleCloseModal () {
        this.props.actionsObject.leftButtonAction();
    }

    buildModalBody() {
        const { modalType, editListName } = this.props;
        const title = formatText(`brokerWatchList-brokerWatchList_${modalType}ModalTitle`, [editListName]);
        const subtitle = formatText(`brokerWatchList-brokerWatchList_${modalType}ModalSubTitle`, [editListName]);
        const leftButtonText = formatText(`brokerWatchList-brokerWatchList_${modalType}ModalLeftButtonText`);
        const rightButtonText = formatText(`brokerWatchList-brokerWatchList_${modalType}ModalRightButtonText`);

        return (
            <div className="event-modal__discard-body">
                <i className="wizard-error-step__error-icon event-modal__icon"/>
                <h3 className="event-modal__title">{title}</h3>
                <span className="event-modal__paragraph">{subtitle}</span>
                <div className="event-modal__footer clearfix">
                    <span className="pull-left">
                        <OKButton modifier="link-ghost" onClick={this.handleCloseModal}>
                            {leftButtonText}
                        </OKButton>
                    </span>
                    <span className="pull-right">
                        <OKButton onClick={this.handleSaveClick}>
                            {rightButtonText}
                        </OKButton>
                    </span>
                </div>
            </div>
        );
    }

    render() {
        const { isModalOpen } = this.props;
        const modalBody = this.buildModalBody();

        return (
            <ModalCustom
                isOpen={isModalOpen}
                onRequestClose={this.handleCloseModal}
                extraClass="event-modal"
            >
                {modalBody}
            </ModalCustom>
        );
    }
}

EventModals.propTypes = {
    editListName: PropTypes.string,
    actionsObject: PropTypes.object,
    handleToggleModal: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    modalType: PropTypes.string,
}

EventModals.defaultProps = {
    isModalOpen: false,
    handleToggleModal: ()=>{},
    modalType: 'discard',
    actionsObject: {
        leftButtonAction: ()=>{},
        rightButtonAction: ()=>{}
    }
}

module.exports = EventModals;
